<template>
	<div class="tc-bar"
		v-bind:class="classBar"
		v-bind:style="styleBar"
	>
		<div class="label-dt"
			v-bind:class="classDateTime"
			v-bind:style="stylePeriod">
			{{setScheduleDateTime}}
		</div>
		<div v-statemachine= "sm_bar">
			<div class="schedule"
				v-bind:class="classSchedule">
			</div>
			<div class="bar-stretch">
				<div class="bar-name"
					v-bind:style="styleName">{{displayName}}</div>
				<div class="left"
					v-bind:class="classBothEnds"
					v-statemachine= "sm_begin">
					<div class="triangle-left"
						v-bind:class="styleTriangleLeftColor"
						v-if="showTriangle" />
				</div>
				<div class="right"
					v-bind:class="classBothEnds"
					v-statemachine= "sm_end">
					<div class="triangle-right"
						v-bind:class="styleTriangleRightColor"
						v-if="showTriangle"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import EventTarget from '../../classes/EventTarget';
import BarEventTarget from '../../classes/BarEventTarget';
import MouseState from '../../classes/MouseState';
import MouseStateMachine from '../../classes/MouseStateMachine';
import clonedeep from 'lodash/cloneDeep';
const BASE_POINT = {
	BEGIN: 0,
	END: 1,
};

export default {
	name: 'TCBar',
	props: [
		"item",
		"schedules",
		"name",
		"isEditable",
		"isExpanded",
		"bar_editing",
	],
	data: function() {
		const state_nop = new MouseState({});
		const state_window_default = new MouseState({
			up: (e, next) => {
				next(this.state_nop);
			},
		});
		
		return {
			state_nop: state_nop,
			state_window_default: state_window_default,
			sm_bar: new MouseStateMachine(state_nop),
			sm_begin: new MouseStateMachine(state_nop),
			sm_end: new MouseStateMachine(state_nop),
			sm_window: new MouseStateMachine(state_nop),
			is_bar_move: false,
			mouse_position: {
				distance: 0,
				base_point: BASE_POINT.BEGIN,
			},
		};
	},
	mounted: function() {
		this.changeState();
	},
	methods: {
		changeState: function () {
			this.sm_bar.next(this.defaultStateBar());
			this.sm_begin.next(this.defaultStateBegin());
			this.sm_end.next(this.defaultStateEnd());
			this.sm_window.next(this.state_nop);
		},
		defaultStateBar: function() {
			if (!this.isEditable)
				return this.state_nop;
			
			const state_default = new MouseState({
				down: (e) => {
					e.stopPropagation();
					
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.setRelativePositionBeginAndMouse(obj);
					this.$emit('bar-move-start',  new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_MOVE,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.item);
					this.sm_bar.next(state_selected_ber);
				},
			});
			const state_selected_ber = new MouseState({
				move: (e) => {
					e.preventDefault();
					this.changeState();
				},
				longpress: (e) => {
					e.stopPropagation();
					this.changeState();
				},
				up: (e) => {
					this.sm_bar.next(state_bar_click);
				},
			});
			const state_bar_click = new MouseState({
				click: (e) => {
					this.$emit('update_schedule_info', {
						target: clonedeep(this.item), 
						schedules: this.schedules,
					});
					this.changeState();
				},
			});

			return state_default;
		},
		defaultStateBegin: function() {
			if (!this.isEditable)
				return this.state_nop;
			
			const state_default = new MouseState({
				down: (e) => {
					e.stopPropagation();
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.setRelativePositionBeginAndMouse(obj);
					this.$emit('bar-stretch-start', new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_BEGIN,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.item);
				},
				longpress: (e) => {
					e.stopPropagation();
				},
				move: (e) => {
					e.preventDefault();
				},
			});
			return state_default;
		},
		defaultStateEnd: function() {
			if (!this.isEditable)
				return this.state_nop;
			
			const state_default = new MouseState({
				down: (e) => {
					e.stopPropagation();
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					this.setRelativePositionEndAndMouse(obj);
					this.$emit('bar-stretch-start', new BarEventTarget({
						target: this,
						target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_END,
						x: obj.pageX,
					}));
					this.$emit('request-ghost-schedule', this.item);
				},
				longpress: (e) => {
					e.stopPropagation();
				},
				move: (e) => {
					e.preventDefault();
				},
			});
			
			return state_default;
		},
		setRelativePositionBeginAndMouse: function(obj) {
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let begin_as_minutes = this.item.begin.getDiffFromDateAsMinutes(source_begin);
			let distance_begin = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
			let page_x = obj.pageX;
			
			this.mouse_position.distance = page_x - (distance_begin - this.hscroll) - this.$store.getters['chart/listWidth'];
			this.mouse_position.base_point = BASE_POINT.BEGIN;
		},
		setRelativePositionEndAndMouse: function(obj) {
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let end_as_minutes = this.item.end.getDiffFromDateAsMinutes(source_begin);
			let distance_end = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes);
			let page_x = obj.pageX;
			
			this.mouse_position.distance = page_x - (distance_end - this.hscroll) - this.$store.getters['chart/listWidth'];
			this.mouse_position.base_point = BASE_POINT.END;
		},
		getBarNameWidth: function() {
			let span = document.createElement('span');
			span.innerHTML = this.displayName;
			span.style.visibility = 'hidden';
			document.body.appendChild(span);
			
			let width = span.offsetWidth;
			
			document.body.removeChild(span);
			
			return width;
		},
	},
	computed: {
		classBar: function() {
			let classes = new Array();
			if (this.isEditable)
				classes.push('bar-move');
			
			return classes;
		},
		classSchedule: function() {
			let classes = new Array();
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if((this.item.project_code === '' && this.item.member_code !== ''))
					classes.push('task');
				else if((this.item.project_code !== '' && this.item.member_code !== ''))
					classes.push('task_project');
			} else {
				if(this.item.isTaskSchedule)
					classes.push('task_project');
				else
					classes.push('project');
			}
			
			return classes;
		},
		classBothEnds: function() {
			let classes = new Array();
			
			if (this.isEditable)
				classes.push('bar-resize');
			
			return classes;
		},
		classDateTime: function() {
			let classes = new Array();
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if((this.item.project_code === '' && this.item.member_code !== ''))
					classes.push('dt_task');
				else if((this.item.project_code !== '' && this.item.member_code !== ''))
					classes.push('dt_task_project');
			} else {
				if(this.item.isTaskSchedule)
					classes.push('dt_task_project');
				else
					classes.push('dt_project');
			}
			return classes;
		},
		styleBar: function() {
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.item.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.item.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			return {
				"left": (this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes)) + "px",
				"width": (this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes - begin_as_minutes)) + 'px',
			};
		},
		styleTriangleLeftColor: function() {
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if(!this.item.isAssociatedProject)
					return 'triangle-left-task-color';
				else
					return 'triangle-left-task-project-color';
			} else {
				if(this.item.isTaskSchedule)
					return 'triangle-left-task-color';
				else
					return 'triangle-left-project-color';
			}
		},
		styleTriangleRightColor: function() {
			if(this.$store.getters['chart/isDisplayMemberList']) {
				if(!this.item.isAssociatedProject)
					return 'triangle-right-task-color';
				else
					return 'triangle-right-task-project-color';
			} else {
				if(this.item.isTaskSchedule)
					return 'triangle-right-task-color';
				else
					return 'triangle-right-project-color';
			}
		},
		stylePeriod: function() {
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.item.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.item.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			let distance_begin = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
			let distance_end = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes);
			let innerWidth = this.$store.getters['chart/innerWidth'];
			
			if (this.mouse_position.distance != 0) {
				let distance = 0;
				if (this.mouse_position.base_point === BASE_POINT.BEGIN)
					distance = this.mouse_position.distance;
				else if (this.mouse_position.base_point === BASE_POINT.END)
					distance = distance_end - distance_begin + this.mouse_position.distance;
				
				if (distance_begin + distance < this.hscroll) {
					distance = this.hscroll - distance_begin;
				} else if (distance_begin + distance + 25 + this.widthLabel > innerWidth) {
					distance = innerWidth - distance_begin - 25 - this.widthLabel;
				}
				
				return {
					"left": distance + 'px',
				};
			}
			
			if (this.hscroll < (distance_begin + 5) || this.hscroll > distance_end)
				return{
				"left": '5px',
			}
			
			return {
				"left": (this.hscroll - distance_begin) + 'px',
			};
		},
		styleName: function() {
			let name_width = this.getBarNameWidth();
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.item.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.item.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			let distance_begin = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
			let distance_end = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes);
			let innerWidth = this.$store.getters['chart/innerWidth'];
			
			let distance = 0;
			let width = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes - begin_as_minutes) - 10;
			let display = 'block';
			
			if (this.mouse_position.distance != 0) {
				
				if (this.mouse_position.base_point === BASE_POINT.BEGIN) {
					distance = this.mouse_position.distance < 15 ? 15 : this.mouse_position.distance;
					if(distance > 15 && distance_begin + distance + name_width + 15 > distance_end) {
						distance = distance_end - distance_begin - 15 - name_width;
					}
				} else if (this.mouse_position.base_point === BASE_POINT.END) {
					distance = distance_end - distance_begin + this.mouse_position.distance - name_width - 15;
				}
				if (distance_begin + distance < this.hscroll) {
					distance = this.hscroll - distance_begin;
				} else if (distance_begin + distance + 25 + name_width > innerWidth) {
					distance = innerWidth - distance_begin - 25 - name_width;
					if(innerWidth - distance_begin - 15 < name_width)
						distance = 15;
				}
				
				if (distance < 15)
					distance = 15;
				width -= distance;
				if (width < 15)
					display = 'none';
				return {
					"left": distance + 'px',
					"width": width + 'px',
					"display": display,
				};
			}
			
			if (this.hscroll < distance_begin + 15 || this.hscroll > distance_end) {
				width -= 15;
				if (width < 15)
					display = 'none';
				return {
					"left": "15px",
					"width": width + 'px',
					"display": display,
				};
			}
			
			distance = this.hscroll - distance_begin;
			if(distance_begin + distance + name_width + 15 > distance_end) {
				distance = distance_end - distance_begin - 15 - name_width;
			}
			width -= distance;
			if (width < 15)
				display = 'none';
			return {
				"left": distance + 'px',
				"width": width + 'px',
				"display": display,
			};
		},
		showTriangle: function() {
			return this.isEditable;
		},
		setScheduleDateTime: function() {
			if(!this.item.isSingleDay) {
				return this.item.begin.strftimeDCL('%m月%d日 %H:%M') + '～' + this.item.end.strftimeDCL('%m月%d日 %H:%M');
			}
			return this.item.begin.strftimeDCL('%H:%M') + '～' + this.item.end.strftimeDCL('%H:%M');
		},
		displayName: function() {
			if (this.$store.getters['chart/isDisplayMemberList']
				&& !this.isExpanded) {
					let task = this.$store.getters.task(this.item.task_code)
					if (task === null)
						return this.name;
					
					return task.name;
			} else {
				return this.name;
			}
		},
		hscroll: function() {
			return this.$store.getters['chart/hscroll'];
		},
		isEditing: function() {
			return this.bar_editing.is_editing;
		},
		widthLabel: function() {
			return this.item.isSingleDay ? 95 : 221;
		},
	},
	watch: {
		isEditable: function() {
			this.sm_bar.next(this.defaultStateBar());
			this.sm_begin.next(this.defaultStateBegin());
			this.sm_end.next(this.defaultStateEnd());
		},
		isEditing: function() {
			if(!this.bar_editing.is_editing) {
				this.mouse_position.distance = 0;
			}
		},
	},
	created: function() {
		this.sm_window.bind(window);
	},
	beforeDestroy: function() {
		this.sm_window.unbind(window);
	},
}
</script>
<style>
	.tc-bar {
		display: inline-block;
		margin-top: 18px;
		height: 27px;
		position: absolute;
		border-radius: 13px;
		border-style: none;
		text-align: center;
	}
	.schedule {
		position: absolute;
		height: 100%;
		width:100%;
		opacity: .5;
		border-radius: 13px;
	}
	.schedule.project {
		border-color: rgba(255, 0, 0, 1);
		background-color: purple;
	}
	.schedule.task {
		border-color: rgba(255, 0, 0, 1);
		background-color: #00f;
	}
	.schedule.task_project {
		border-color: rgba(255, 0, 0, 1);
		background-color: green;
	}
	.tc-bar.bar-move {
		cursor: move;
	}
	.tc-bar .bar-resize {
		cursor: w-resize;
	}
	.tc-bar .left {
		position: absolute;
		left: 0;
		display: inline-block;
		height: 27px;
		width: 10px;
	}

	.tc-bar .right {
		position: absolute;
		right: 0;
		display: inline-block;
		height: 27px;
		width: 10px;
	}
	.triangle-left {
		position: absolute;
		top: 6px;
		left: 3px;
		width: 0;
		height: 0;
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-right: 7px solid;
	}

	.triangle-left-project-color {
		border-right-color: #E0E0FF;
	}
	.triangle-left-task-color {
		border-right-color: #E0FFFF;
	}
	.triangle-left-task-project-color {
		border-right-color: #E0FFE0;
	}
	.triangle-right {
		position: absolute;
		top: 6px;
		right: 5px;
		width: 0;
		height: 0;
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-left: 7px solid;
	}

	.triangle-right-project-color {
		border-left-color: #E0E0FF;
	}
	.triangle-right-task-color {
		border-left-color: #E0FFFF;
		
	}
	.triangle-right-task-project-color {
		border-left-color: #E0FFE0;
		
	}
	.bar-stretch {
		position: absolute;
		width: 100%;
		z-index: 102;
	}
	.bar-name {
		position: absolute;
		height: 1.5rem;
		overflow: hidden;
		word-wrap: normal;
		text-align: left;
		padding: 3px 0 3px 0;
		opacity: 1;
		
	}
	.label-dt {
		left: 5px;
		position: absolute;
		color: black;
		top: -15px;
		white-space: nowrap;
		padding: 0px 2px 0px 2px;
		background-color:#fefefe;
		text-align: left;
		font-size: 14px;
		padding: 0px 5px 0px 5px;
		border-bottom: 1px solid gray;
		border-left: 1px solid #c3c3c3;
		box-shadow: 2px 2px 4px grey;
		z-index: 101;
		cursor: default;
		line-height: 16px;
		height: 16px;
	}
	.dt_project {
		color: purple;
	}
	
	.dt_task {
		color: blue;
	}
	.dt_task_project {
		color: green;
	}
	
</style>
<style scoped>
	.v-btn--floating {
		position: absolute;
		right: -12px;
		top: -12px;
		opacity: 1;
	}

	.v-btn--floating.v-btn--small {
		width: 16px;
		height: 16px;
	}
</style>
